import { GridLayout } from './GridLayout';
import { List } from './List';
import { Viewer } from './Viewer';

export const layoutsMap = {
  grid: GridLayout,
  list: List,
  viewer: Viewer
};
